import React from 'react';
import { styled } from '@mui/system';
import { useTheme } from '@mui/material/styles';

// Define badge size variants using theme variables
const badgeSizes = (theme) => ({
    small: {
        padding: `5px`,
        fontSize: theme.typography.textXS.fontSize,
        lineHeight: theme.typography.textXS.lineHeight,
    },
    medium: {
        padding: `${theme.customSpacing.sm}`,
        fontSize: theme.typography.textSM.fontSize,
        lineHeight: theme.typography.textSM.lineHeight,
    },
    large: {
        padding: `${theme.customSpacing.md}`,
        fontSize: theme.typography.textSM.fontSize,
        lineHeight: theme.typography.textSM.lineHeight,
    },
});

// Define badge variants using theme variables
const badgeVariants = (theme) => ({
    iconBadge: {
        borderRadius: theme.shape.radius.full,
        border: `1px solid ${theme.palette.border.secondary}`,
        background: theme.palette.background.secondary,
        color: theme.palette.foreground.disabled,
    },
    iconBadgeError: {
        borderRadius: theme.shape.radius.full,
        border: `1px solid ${theme.palette.border.error}`,
        background: theme.palette.background.error_primary,
        color: theme.palette.foreground.error_primary,
    },
    iconBadgeWarning: {
        borderRadius: theme.shape.radius.full,
        border: `1px solid ${theme.palette.border.warning}`,
        background: theme.palette.background.warning_primary,
        color: theme.palette.foreground.warning_primary,
    },
    iconBadgeSuccess: {
        borderRadius: theme.shape.radius.full,
        border: `1px solid ${theme.palette.border.success}`,
        background: theme.palette.background.success_primary,
        color: theme.palette.foreground.success_primary,
    },
});

const IconWrapper = styled('span')(({ variant, size, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...badgeSizes(theme)[size],
    ...badgeVariants(theme)[variant],
    '& svg': {
        width: '14px',
        height: '14px',
    }
}));

const DefaultIconBadge = ({ variant = 'iconBadge', icon = null, size = 'small', ...props }) => {
    const theme = useTheme();
    return <IconWrapper variant={variant} size={size} {...props}>{icon}</IconWrapper>
};

export default DefaultIconBadge;
